module.exports = __webpack_public_path__ + "img/fulllink.6440d677.jpg";